import React from 'react';
import {Grid, Stack} from '@mui/material';
import "../../css/Schedule.css";

const renderUnAccreditedServiceOverlay = (unAccreditedServiceOverlay) => {
    if (!unAccreditedServiceOverlay || unAccreditedServiceOverlay.length === 0) {
        return null;
    }

    return unAccreditedServiceOverlay.map((overlay, idx) => (
        <Stack
            key={idx}
            className="unaccredited-service-overlay"
            sx={{
                '--index': overlay.index,
                '--sectionHeight': overlay.sectionHeight,
                '--startPercent': overlay.startPercent,
                '--widthPercent': overlay.widthPercent,
                '--backgroundColor': overlay.pattern
            }} />
    ));
};

export default function ShiftPlanTimeblockRow({
    timeblocks,
    performer,
    availableServiceTypes,
    buildTimeblockCellStyle,
    handlePerformerShiftSelectionByIndividualTimeBlock
}){
    return timeblocks.map((timeblock, colIdx) => {
        const cellRenderInfo = buildTimeblockCellStyle(performer, timeblock, availableServiceTypes);

        return (
            <Grid
                item
                key={colIdx}
                sx={cellRenderInfo.style}
                onClick={() => handlePerformerShiftSelectionByIndividualTimeBlock(performer, timeblock)}>
                {renderUnAccreditedServiceOverlay(cellRenderInfo.unAccreditedServiceOverlay)}
            </Grid>
        );
    });
};